import React from 'react';
import { Paper, Title, Text, Stack } from '@mantine/core';

function WebsiteSettings() {
  React.useEffect(() => {
    // Initialize Typeform embed
    const script = document.createElement('script');
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Stack p="md">
      <Title order={3}>Website Settings</Title>
      <Text size="sm" c="dimmed" mb="md">
        Configure your website settings and preferences
      </Text>
      <div data-tf-live="01JQSAEBAW26X1MTHCD0J9XK0K"></div>
    </Stack>
  );
}

export default WebsiteSettings; 